import { lazy } from 'react';

// Prometheus (Agent Updates)
export const PrometheusDashboard = lazy(() =>
  import('@/capabilities/agent-release-management/pages/PrometheusDashboard').then((m) => ({ default: m.PrometheusDashboard }))
);

export const ReleasesPage = lazy(() =>
  import('@/capabilities/agent-release-management/pages/ReleasesPage').then((m) => ({ default: m.ReleasesPage }))
);

export const RolloutPage = lazy(() =>
  import('@/capabilities/agent-release-management/pages/RolloutPage').then((m) => ({ default: m.RolloutPage }))
);

export const PatchCompliancePage = lazy(() =>
  import('@/capabilities/agent-release-management/pages/PatchCompliancePage').then((m) => ({ default: m.PatchCompliancePage }))
);

export const PatchRolloutPage = lazy(() =>
  import('@/capabilities/agent-release-management/pages/PatchRolloutPage').then((m) => ({ default: m.PatchRolloutPage }))
);
